import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const [counters, setCounters] = useState({
    content: 0,
    clients: 0,
    coffee: 0
  });

  useEffect(() => {
    const targets = {
      content: 21356,
      clients: 30,
      coffee: 1560
    };

    const duration = 2000;
    const steps = 60;
    const stepTime = duration / steps;

    const incrementCounters = () => {
      let step = 0;
      const timer = setInterval(() => {
        step++;
        const progress = step / steps;
        
        setCounters({
          content: Math.floor(targets.content * progress),
          clients: Math.floor(targets.clients * progress),
          coffee: Math.floor(targets.coffee * progress)
        });

        if (step >= steps) {
          clearInterval(timer);
          setCounters(targets);
        }
      }, stepTime);
    };

    const startDelay = setTimeout(incrementCounters, 500);

    return () => {
      clearTimeout(startDelay);
    };
  }, []);

  return (
    <section data-hero="true" className="min-h-screen flex items-center pt-16 sm:pt-20 lg:pt-24 relative overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0 w-full h-full">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
          style={{ filter: 'brightness(0.4) contrast(1.2)' }}
        >
          <source
            src="https://player.vimeo.com/progressive_redirect/playback/859695423/rendition/1080p/file.mp4?loc=external&signature=7119d864cd27577b5b49a8bac9f9d1e41e3b56c948402e120d71f6ce76223fc7"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Black overlay for better text readability */}
      <div className=""></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10">
        <div className="flex items-center justify-center min-h-[80vh]">
          <div className="space-y-6 sm:space-y-8 text-center lg:text-left max-w-5xl">
            <div className="space-y-6 sm:space-y-8">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl font-AfacadFluxLight font-bold tracking-wide uppercase leading-tight text-white break-words">
                WE POWER-UP START-UPs
              </h1>
              
              <p className="text-base sm:text-md md:text-lg lg:text-xl text-gray-300 font-AfacadFluxLight leading-relaxed max-w-5xl font-light">
                We are one of the top tier start-up assist services providers that boasts being the Boosterjets for multimillion dollar success stories to lift off with greater thrust, from around the world, mainly United States, United Kingdom, Australia, UAE, Singapore and many more. Headquartered in WY, USA with branch offices in NSW, Australia and Colombo, Sri Lanka, there is no better Knowledgeable, Experienced, Resourceful and Trusted (KERT) partner to turn towards than VENTURECORP.
              </p>
            </div>
            
            {/* CTA Button */}
            <div className="pt-2 sm:pt-4">
              <Link to="/contact" className="inline-block w-full sm:w-auto bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-6 sm:px-8 lg:px-10 py-3 sm:py-3 lg:py-3 rounded-lg font-medium hover:from-purple-700 hover:to-indigo-700 transform hover:-translate-y-1 transition-all duration-300 shadow-lg hover:shadow-xl font-AfacadFluxLight uppercase tracking-wide text-sm sm:text-base text-center">
                Join us
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* White separator line at bottom */}
      {/* <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2  w-4/5 h-1 bg-white/20"></div> */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-4/5 h-0.5 bg-white/50"></div>


    </section>
  );
};

export default Hero; 